export const onlyPositiveIntegersWithFractionsRegEx = /^(d*[1-9]\d*(\.[0-9]*)?|(\.[0-9]+))$/;
